"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorDialog_1 = require("./errorDialog");
function RenderNetworkErrorDialog(close) {
    return React.createElement(errorDialog_1.ErrorDialog, { close: close, singleTabText: "Disconnected" },
        React.createElement("h2", null, "Connection lost"),
        React.createElement("p", null, "The connection has been lost.  Please attempt to restore your internet connection and try the current operation again."));
}
exports.RenderNetworkErrorDialog = RenderNetworkErrorDialog;
